import { isDotCom } from '@src/site';

/** Site presentation only. Experiment prices are owned by /api/premium/offer. */
export const PREMIUM_SITES = {
  ru: {
    currency: 'RUB',
    origin: 'https://santa-secret.ru',
    showAdsBenefit: true,
    showOrganizerSupportPanel: true,
  },
  com: {
    currency: 'USD',
    origin: 'https://santa-secret.com',
    showAdsBenefit: false,
    showOrganizerSupportPanel: false,
  },
} as const;
export type PremiumQuote = {
  features?: import('@lub0v/santa-utils').PremiumFeatures;
  offerCode?: string;
  experiment: string;
  variant: import('@lub0v/santa-utils').PremiumVariant;
  amountMinor: number;
  checkoutAmountMinor?: number;
  currency: string;
  paymentUrl: string | null;
  paymentsAvailable?: boolean;
};
let currentQuote: PremiumQuote | null = null;
export function setCurrentPremiumQuote(quote: PremiumQuote | null) {
  currentQuote = quote;
}
export function premiumOffer(language = 'en', quote: PremiumQuote | null = currentQuote) {
  const site = isDotCom() ? 'com' : 'ru';
  const offer = { ...PREMIUM_SITES[site], amount: quote ? quote.amountMinor / 100 : 0 };
  const fractionDigits = Number.isInteger(offer.amount) ? 0 : 2;
  const format = { minimumFractionDigits: fractionDigits, maximumFractionDigits: 2 };
  const formattedPrice = new Intl.NumberFormat(language, {
    style: 'currency',
    currency: offer.currency,
    ...format,
  }).format(offer.amount);
  const symbolPrice =
    offer.currency === 'RUB'
      ? `${new Intl.NumberFormat(language, format).format(offer.amount)} ₽`
      : new Intl.NumberFormat(language, {
          style: 'currency',
          currency: offer.currency,
          currencyDisplay: 'narrowSymbol',
          ...format,
        }).format(offer.amount);
  return {
    ...offer,
    site,
    formattedPrice: quote ? formattedPrice : '…',
    symbolPrice: quote ? symbolPrice : '…',
    experiment: quote?.experiment,
    variant: quote?.variant,
    offerCode: quote?.offerCode,
    features: quote?.features,
    amountMinor: quote?.amountMinor,
    checkoutAmountMinor: quote?.checkoutAmountMinor,
    paymentUrl: quote?.paymentUrl ?? null,
    paymentsAvailable: quote?.paymentsAvailable === true,
    ready: Boolean(quote),
  };
}
